
<template>
	<component :is="productData === undefined ? 'div' : 'b-card'">
		<!-- Alert: No item found -->
		<b-alert
			variant="danger"
			:show="productData === undefined"
		>
			<h4 class="alert-heading">Error al obtener los datos del producto</h4>
			<div class="alert-body">
				No se encontró ningún producto con este id. Verificar en la
				<b-link
					class="alert-link"
					:to="{ name: 'products'}"
				>Lista de productos</b-link>para buscar otro producto.
			</div>
		</b-alert>

		<b-tabs
			v-if="productData"
			pills
		>
			<!-- Tab: Information -->
			<b-tab>
				<template #title>
					<feather-icon
						icon="InfoIcon"
						size="16"
						class="mr-0 mr-sm-50"
					/>
					<span class="d-none d-sm-inline">Información</span>
				</template>
				<product-edit-tab-information
					class="mt-2 pt-75"
					:product-data="productData"
				/>
			</b-tab>
		</b-tabs>
	</component>
</template>

<script>
import ProductEditTabInformation from "./ProductEditTabInformation.vue"
import { BAlert, BCard, BLink, BTab, BTabs } from "bootstrap-vue"
import { onUnmounted, ref } from "@vue/composition-api"
import productStoreModule from "../productStoreModule"
import router from "@/router"
import store from "@/store"

export default {
	components: {
		BTab,
		BTabs,
		BCard,
		BAlert,
		BLink,

		ProductEditTabInformation
	},
	setup() {
		const productData = ref(null)

		/* 25 -> "25.00". Se deja intacto lo que no sea un numero valido: un
		   precio vacio debe seguir vacio, no convertirse en 0.00. */
		const dosDecimales = (valor) => {
			const numero = Number(valor)

			return Number.isFinite(numero) && valor !== null && valor !== ''
				? numero.toFixed(2)
				: valor
		}

		/* Alcanza al producto, a sus variantes y a las sub-variantes de cada una. */
		const conPreciosFormateados = (producto) => {
			if (!producto) return producto

			/* Cada nivel guarda el precio en dos campos, "price" y "price_init",
			   y el formulario lee uno u otro segun el caso: se formatean los dos
			   para que no dependa de cual toque. */
			const ambos = (objeto) => {
				if (!objeto) return
				objeto.price = dosDecimales(objeto.price)
				objeto.price_init = dosDecimales(objeto.price_init)
			}

			ambos(producto)

			;(producto.variants || []).forEach((variante) => {
				ambos(variante)

				;(variante.subVariants || []).forEach(ambos)
			})

			return producto
		}

		const USER_APP_STORE_MODULE_NAME = "app-product"

		// Register module
		if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
			store.registerModule(USER_APP_STORE_MODULE_NAME, productStoreModule)

		// UnRegister on leave
		onUnmounted(() => {
			if (store.hasModule(USER_APP_STORE_MODULE_NAME))
				store.unregisterModule(USER_APP_STORE_MODULE_NAME)
		})

		store
			.dispatch("app-product/fetchProduct", {
				id: router.currentRoute.params.id
			})
			.then((response) => {
				console.log("error response", response)
				if (response.data === "error") {
					productData.value = undefined
				} else {
					productData.value = conPreciosFormateados(response.data)
				}
			})
			.catch((error) => {
				console.log("error catch", error)
				if (error.response.status === 404) {
				}
				productData.value = undefined
			})

		return {
			productData
		}
	}
}
</script>